<template>
<el-menu
    mode="horizontal"
    class="default"
    :class="`${getPrimaryColor} ${(!logged && !selection) || (!logged && selection)  ? 'w-100' : ''} ${!logged || selection ? 'not-logged-in' : ''}`"
>
    <div class="container-fluid d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
            <div @click="toggleNavbar" class="navbar-visibility" v-if="logged">
                <MenuIcon />
            </div>
            <el-menu-item index="1" class="m-2 border-right-0" v-if="(!logged && !selection) || selection">
                <WhitelabelLogo :logo="companyLogos[getWhiteLabel]"/>
            </el-menu-item>
        </div>
        <div class="d-flex align-items-center">
            <el-menu-item index="2" v-if="logged && !selection">
                <el-dropdown trigger="click" >
                    <div class="el-dropdown-link c-nmidtwo support-span">
                        <img src="@/assets/imgs/icons/help.svg">
                        Suporte
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <SupportDropdownItem
                            :href="`mailto:${this.getContactWhiteLabel.email}`"
                            icon="Email"
                            title="E-mail:"
                            :content="this.getContactWhiteLabel.email"
                            class=""
                        />
                        <SupportDropdownItem
                            :href="this.getContactWhiteLabel.tel.startsWith('0800') ? undefined :`https://web.whatsapp.com/send?phone=${this.getContactWhiteLabel.tel}&text&source&data&app_absent`"
                            icon="WhatsApp"
                            :title="`${this.getContactWhiteLabel.tel.startsWith('0800') ? 'Telefone' : 'WhatsApp:'}`"
                            :content="this.getContactWhiteLabel.tel | formatPhone"
                            class=""
                        />
                    </el-dropdown-menu>
                </el-dropdown>
            </el-menu-item>

            <el-menu-item index="3" class="m-2" v-if="logged || selection">
                <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                        <img src="@/assets/imgs/avatar.svg">
                        <span class="c-ndarkfour company-name">{{ $store.state.user.infos.name || 'Undefined' }}</span>
                        <ArrowDropdown />
                    </span>

                    <el-dropdown-menu class="drop-select" slot="dropdown" width="400px" v-if="selection">
                        <div class="row d-flex align-items-center">
                            <div class="col-8 break-col">
                                <h5 class="bold mb-0">
                                    <img src="@/assets/imgs/avatar.svg" class="mr-2">
                                    <span class="c-ndarkfour">{{ $store.state.user.infos.name || 'Undefined' }}</span>
                                </h5>
                            </div>
                            <div class="col-4">
                                <button @click="gotoLogout" class="btn btn-outline-grey small">
                                    <img src="@/assets/imgs/icons/logout.svg" width="10" class="mr-2">
                                    Sair
                                </button>
                            </div>
                        </div>
                    </el-dropdown-menu>

                    <el-dropdown-menu class="drop-select" slot="dropdown" width="400px" v-else>
                        <div class="row d-flex align-items-center border-bottom pb-3 mb-3">
                            <div class="col-8 d-flex">
                                <Avatar :size="'40'"/>
                                <div class="ml-3 break-col">
                                    <h5 class="bold mb-0">
                                        {{ $store.state.user.infos.name || 'Undefined' }}
                                    </h5>
                                    <h6 class="c-ndarkfour regular mb-0">
                                        {{ $store.state.user.infos.email || 'Undefined' }}
                                    </h6>
                                </div>

                            </div>
                            <div class="col-4">
                                <button @click="gotoLogout" class="btn btn-outline-grey small">
                                    <img src="@/assets/imgs/icons/logout.svg" width="10" class="mr-2">
                                    Sair
                                </button>
                            </div>
                        </div>
                        <div class="company-select">
                            <div class="row px-2 d-flex align-items-center">
                                <div class="col-8 d-flex align-items-center">
                                    <el-tooltip class="item" :content="(selectedCompany.tradingName || selectedCompany.name)" placement="top">
                                        <div class="mb-0 ">
                                            <p class="c-ndarkfour bold break pr-4 w-100 company-name">
                                                {{(selectedCompany.tradingName || selectedCompany.name) | formatName}}
                                            </p>
                                            <h6 class="c-nmidone medium mb-0">
                                                {{selectedCompany.cnpj | formatCnpjOrCpf}}
                                            </h6>
                                        </div>
                                    </el-tooltip>
                                </div>
                                <div class="col-4">
                                    <caption class="mb-0">
                                        {{ selectedCompanyType }}
                                    </caption>
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex align-items-center mt-4" v-if="$store.state.user.companys.length > 1">
                            <div class="col-12">
                                <a :href="`${url.urlClient}/company/select`" class="d-flex align-items-center c-ndarkfour">
                                    <p :class="`c-${getPrimaryColor}four btn small w-100 btn-outline-${getPrimaryColor}`">
                                        <ArrowDropdown :rotate="90" class="mr-2" :color="getPrimaryColorHex.four"/>
                                        Voltar para a seleção de empresas
                                    </p>
                                </a>
                            </div>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-menu-item>

        </div>
    </div>
</el-menu>
</template>

<script>
import ArrowDropdown from '@/components/icons/ArrowDropdown';
import Avatar from '@/components/icons/Avatar.vue';
import SupportDropdownItem from '@/components/navigation/navbar/SupportDropdownItem.vue';
import WhitelabelLogo from './WhitelabelLogo.vue';
import MenuIcon from '@/components/icons/navbar/MenuIcon'
import getWhiteLabel from '@/utils/getWhiteLabel'


export default {
    props: {
        route: {
            required: false,
            type: String,
            default: ''
        },
        logged: {
            required: false,
            type: Boolean,
            default: false
        },
        selection: {
            required: false,
            type: Boolean,
            default: false
        },
    },
    components: {
    ArrowDropdown,
    Avatar,
    SupportDropdownItem,
    WhitelabelLogo,
    MenuIcon,
},

    data() {
        return {
            // selectedCompany: `${JSON.parse(Cookies.get('selectedCompany')).cnpj}-${JSON.parse(Cookies.get('selectedCompany')).companyType}` || '',
            url: {}
        };
    },
    methods: {
        gotoLogout() {
            this.$router.push('/logout')
        },
        toggleNavbar() {
            const { collapse } = this.$store.state.tabs
            this.$store.commit('tabs/setCollapse', !collapse)
        }
    },
    computed: {
        selectedCompany() {
            const { companys, cnpjId, userAdm, partnerAdm } = this.$store.state.user
            if (userAdm) {
                const selected = companys.find(company => company.id === 0)
                const { cnpj, name, tradingName } = selected
                return {
                    cnpj: cnpj.cnpj,
                    companyType: cnpj.companyType,
                    name,
                    tradingName
                }
            } else {
                const selected = companys.find(company => company.cnpj.id == cnpjId)
                const { cnpj, name, tradingName } = selected

                return {
                    cnpj: cnpj.cnpj,
                    companyType: cnpj.companyType,
                    name,
                    tradingName,
                    partnerAdm
                }
            }
        },
        selectedCompanyType() {
            const { companyType, partnerAdm } = this.selectedCompany
            if (companyType == 3) {
                if (partnerAdm) {
                    return getWhiteLabel()
                }
                return 'Cashforce'
            }

            const companyTypes = ['Financiador', 'Fornecedor', 'Comprador']
            return companyTypes[companyType]
        },
        companyLogos() {
            return {
                CASHFORCE: {
                    name:  "LogoCashforce",
                    width: "130",
                    height: "35",
                },
                TECBAN: {
                    name:  "LogoTecban",
                    width: "100",
                    height: "35",
                },
                CIABRA: {
                    name:  "LogoCiabra",
                    width: "130",
                    height: "35",
                },
                "FUNDO MULTI SUPERMERCADOS": {
                    name:  "LogoFMS",
                    width: "130",
                    height: "35",
                },
                NETMONEY: {
                    name:  "LogoNetmoney",
                    width: "130",
                    height: "35",
                },
                "OS INTELIGENCIA FINANCEIRA": {
                    name:  "LogoCashforce",
                    width: "130",
                    height: "35",
                },
                "POE NA TELA": {
                    name:  "LogoCashforce",
                    width: "130",
                    height: "35",
                },
                "VIA INVEST": {
                    name:  "LogoViaInvest",
                    width: "130",
                    height: "35",
                },
                "M7": {
                    name:  "LogoM7",
                    width: "150",
                    height: "35",
                },
                INTRABANK: {
                    name:  "LogoIntrabank",
                    width: "120",
                    height: "36",
                },
                IRIOM: {
                    name:  "LogoIriom",
                    width: "130",
                    height: "35",
                },
                BIZ2BANK: {
                    name:  "LogoBiz2bank",
                    width: "130",
                    height: "35",
                },
                TRIAL: {
                    name:  "LogoCashforce",
                    width: "130",
                    height: "35",
                },
                "SOMOS PREMIUM": {
                    name:  "LogoSomosPremium",
                    width: "130",
                    height: "35",
                },
                CARBON: {
                    name:  "LogoCarbon",
                    width: "102",
                    height: "",
                },
                AMB: {
                    name:  "LogoAmb",
                    width: "130",
                    height: "35",
                },
                MGPAY: {
                    name: "LogoMGpay",
                    width: "130",
                    height: "35",
                },
                UNIVERSO: {
                    name: "LogoUniverso",
                    width: "130",
                    height: "35",
                },
                SOMMA: {
                    name: "LogoSomma",
                    width: "130",
                    height: "35",
                },
                "TRIAL 2": {
                    name:  "LogoCashforce",
                    width: "130",
                    height: "35",
                },
                "TRIAL 3": {
                    name:  "LogoCashforce",
                    width: "130",
                    height: "35",
                },
            }
        }
    },
    created() {
        this.url = { urlClient: this.getServiceUrls.CLIENT }
    },
}
</script>
<style lang="scss" scoped>
.company-name {
    max-width: 200px;
    overflow: hidden;
}
.el-menu--horizontal.pred.default li.el-menu-item {
    height: unset;
    line-height: unset;
}

</style>
